export const getRouteReferences = ( apiInstance: API.Client ) => ( uid: string ) => (
  apiInstance.Entity.collection( 'route' ).getReferences( uid )
)